export default {
  barTitle: 'Файли cookie',
  barDescription: 'Ми використовуємо власні файли cookie та сторонні файли cookie, щоб ми могли показати вам цей веб-сайт і краще зрозуміти, як ви ним користуєтеся, з метою покращення пропонованих нами послуг. Якщо ви продовжуєте перегляд, ми вважаємо, що ви прийняли файли cookie.',
  acceptAll: 'Прийняти усі',
  declineAll: 'Видалити усі',
  manageCookies: 'Керувати файлами cookie',
  unsaved: 'У вас є незбережені налаштування',
  close: 'Закрити',
  save: 'Зберегти',
  necessary: 'Необхідні файли cookie',
  optional: 'Факультативні файли cookie',
  functional: 'Функціональні файли cookie',
  blockedIframe: 'Щоб побачити це, увімкніть функціональні файли cookie',
  here: 'тут'
}
